import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import OfficeService from '../../../Services/OfficeService';
import OfficeItem from './OfficeItem';
import EditOfficeVideoWindowDescription from './EditOfficeVideoWindowDescription';
import DetailedTaxWindow from './DetailedTaxWindow';
import AddNewOfficeOverheadWindowDescription from '../OfficeOverhead/AddNewOfficeOverheadWindowDescription';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditFreelancerInvoiceContactsWindowDescription from './EditFreelancerInvoiceContactsWindowDescription';
import EditOfficeCostGroupLinkWindowDescription from '../OfficeCostGroupLinks/EditOfficeCostGroupLinkWindowDescription';
import EditEmployeeCostGroupSettingsWindowDescription from './EditEmployeeCostGroupSettingsWindowDescription';
import EditOfficeCorporateWindowDescription from './EditOfficeCorporateWindowDescription';
import EditOfficeEmployeeWindowDescription from './EditOfficeEmployeeWindowDescription';
import EditOfficeContactWindowDescription from './EditOfficeContactWindowDescription';
import EditOfficeGeneralWindowDescription from './EditOfficeGeneralWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import FreelancerInvoiceContactEditItem from '../../../Domain/FreelancerInvoiceContactEditItem';
import LookupItemService from '../../../Services/LookupItemService';
import ErrorMessage from '../../../Elements/ErrorMessage';

export default class OfficeAdmin extends React.Component
{
  static defaultProps = {};

  constructor (props)
  {
    super(props);

    this.state = {
      searchItem: {},
      selected: -1,
      selectedOffice: null,
      shownPanel: ShownPanelsEnum.None,
    };

    OfficeItem.editGeneralFunction = this.editGeneralFunction.bind(this);
    OfficeItem.editFICFunction = this.editFICFunction.bind(this);
    OfficeItem.editContactInformationFunction = this.editContactInformationFunction.bind(this);
    OfficeItem.editCorporateCostsFunction = this.editCorporateCostsFunction.bind(this);
    OfficeItem.editEmployeeDailyCostsFunction = this.editEmployeeDailyCostsFunction.bind(this);
    OfficeItem.editVideoCostsFunction = this.editVideoCostsFunction.bind(this);
    OfficeItem.editEmployeeCostGroupSettingsFunction = this.editEmployeeCostGroupSettingsFunction.bind(this);
    OfficeItem.editOfficeCostGroupLinkFunction = this.editOfficeCostGroupLinkFunction.bind(this);
    this.showPanel = this.showPanel.bind(this);
  }

  editGeneralFunction (id, office)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditGeneral,
      selectedOffice: office,
    });
  }

  editFICFunction (id, office)
  {
    const editItem = new FreelancerInvoiceContactEditItem(office);

    this.setState({
      shownPanel: ShownPanelsEnum.EditFIC,
      selectedOffice: editItem,
    });
  }

  editContactInformationFunction (id, office)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditContact,
      selectedOffice: office,
    });
  }

  editCorporateCostsFunction (id, office)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditCorporate,
      selectedOffice: office,
    });
  }

  editEmployeeDailyCostsFunction (id, office)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditEmployee,
      selectedOffice: office,
    });
  }

  editVideoCostsFunction (id, office)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditVideo,
      selectedOffice: office,
    });
  }

  editEmployeeCostGroupSettingsFunction (setting)
  {
    // The setting itself only carries costGroupLookupItemId; resolve its display text before
    // opening the panel (the wizard snapshots editedItem once at construction and does not
    // re-sync from later prop changes, so the fetch must finish before the panel is shown).
    LookupItemService.GetLookupItemById(setting.costGroupLookupItemId)
      .then((item) =>
      {
        this.setState({
          shownPanel: ShownPanelsEnum.EditCostGroupSetting,
          selectedOffice: { ...setting, costGroupText: item ? item.text : '' },
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('OA99'));
  }

  editOfficeCostGroupLinkFunction (link)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditCostGroupLink,
      selectedOffice: link,
    });
  }

  showPanel (panelId)
  {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  refresh (reload = false)
  {
    if (reload)
    {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else
    {
      this.setState({ shownPanel: ShownPanelsEnum.None });
    }
  }

  renderButtonsAndPanels ()
  {
    return (
      <>
        <ButtonRow
          labels={[ 'Create Overhead' ]}
          colors={[ ButtonColorsEnum.Primary ]}
          keys={[ ShownPanelsEnum.AddNewItem ]}
          icons={[ 'fa-solid fa-chart-line' ]}
          roleKeys={[ 'createofficeoverheadbutton' ]}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  renderPanels ()
  {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditGeneral,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOfficeGeneralWindowDescription}
            errorCode='OFF-GEN-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditFIC,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditFreelancerInvoiceContactsWindowDescription}
            errorCode='EFIC117'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditContact,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOfficeContactWindowDescription}
            errorCode='OFF-CONTACT-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditCorporate,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOfficeCorporateWindowDescription}
            errorCode='OFF-CORP-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditEmployee,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOfficeEmployeeWindowDescription}
            errorCode='OFF-EMP-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditVideo,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOfficeVideoWindowDescription}
            errorCode='OFF-VID-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={AddNewOfficeOverheadWindowDescription.buildItem()}
            onChangeEditedItem={AddNewOfficeOverheadWindowDescription.onChangeEditedItem}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh()}
            windowDescription={AddNewOfficeOverheadWindowDescription}
            errorCode='OFF-OVH-ADD'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditCostGroupSetting,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditEmployeeCostGroupSettingsWindowDescription}
            errorCode='OFF-CGS-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditCostGroupLink,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedOffice}
            clickOnCancel={() => this.refresh()}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOfficeCostGroupLinkWindowDescription}
            errorCode='OFF-CGL-EDIT'
          />
        )}
        {/* {this.renderOnePanel(
          ShownPanelsEnum.DetailedTaxWindow,
          <DetailedTaxWindow clickOnCancel={() => this.refresh()} />
        )} */}
      </div>
    );
  }

  renderOnePanel (panelId, content)
  {
    return this.state.shownPanel === panelId ? content : null;
  }

  render ()
  {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OfficeItem}
          popupEnabled={true}
          shownPanel={this.state.shownPanel}
          serviceFunction={OfficeService.GetOfficeList}
          convertDBItemsFunction={OfficeService.ConvertDBEvaluator}
          searchItem={this.state.searchItem}
          errorCode='OA176'
        />
        {this.renderButtonsAndPanels()}
      </div>
    );
  }
}
